import { Link } from "react-router-dom";
import LazyYouTube from "./LazyYouTube";



const PhotoCollage = () => {
  return (
    <section className="py-24 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center text-3xl md:text-4xl font-semibold text-primary mb-2">
          Impressionen
        </h2>
        <h3 className="text-center text-lg md:text-xl font-light text-primary/80 mb-12 tracking-[0.2em]">
          Einblicke in den Luther Club
        </h3>

        {/* Grid: video left + images right */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 auto-rows-[160px] md:auto-rows-[200px]">

          {/* YouTube Video – 9:16, spans 2 rows on left */}
          <div className="row-span-2 rounded-lg overflow-hidden relative bg-black">
            <LazyYouTube
              videoId="rLQeUEVbuB0"
              title="Luther Club Video"
              className="absolute top-1/2 left-1/2"
              style={{ width: "300%", height: "100%", transform: "translate(-50%, -50%)" }} />
          </div>



          {/* Image 1 – Outdoor Party (wide) */}
          <div className="col-span-1 md:col-span-2 relative group overflow-hidden rounded-lg">
            <img
              src="/images/collage-1.webp"
              alt="Outdoor Party"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy" />
            
            <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-300" />
          </div>

          {/* Image 2 – Barkeeperin */}
          <div className="relative group overflow-hidden rounded-lg">
            <img
              src="/images/collage-2.webp"
              alt="Barkeeperin"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy" />
            
            <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-300" />
          </div>

          {/* Image 3 – Drinks */}
          <div className="relative group overflow-hidden rounded-lg">
            <img
              src="/images/collage-3.webp"
              alt="Cocktails"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy" />
            
            <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-300" />
          </div>

          {/* Image 4 – Gast lächelnd */}
          <div className="relative group overflow-hidden rounded-lg">
            <img
              src="/images/collage-4.webp"
              alt="Gast"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy" />
            
            <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-300" />
          </div>

          {/* Image 5 – Party Freundinnen */}
          <div className="relative group overflow-hidden rounded-lg">
            <img
              src="/images/collage-5.webp"
              alt="Party"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy" />
            
            <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-300" />
          </div>

          {/* Image 6 – DJ (wide) */}
          







          
        </div>

        <div className="text-center mt-10">
          <Link
            to="/gallery"
            className="inline-flex items-center gap-2 font-[Montserrat] text-sm tracking-[0.15em] uppercase text-primary hover:text-primary/80 transition-colors group">
            
            Alle Bilder ansehen
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </Link>
        </div>
      </div>
    </section>);

};

export default PhotoCollage;